import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {BottomNavComponent} from '@on-the-go-web/components/bottom-nav/bottom-nav.component';
import {SidenavComponent} from '@on-the-go-web/components/sidenav/sidenav.component';
import {SecurityPromptComponent} from '@on-the-go-web/components/security-prompt/security-prompt.component';
import {AuthService} from '@on-the-go-web/helpers/services/auth.service';
import {LOGO_PATH_TOKEN} from '@on-the-go-web/library';
// Deep imports, not the components barrel: this shell is in the initial
// bundle, and the barrel would pull every shared component into it.
import {CopilotDrawer} from '@on-the-go-web/library/components/copilot-drawer/copilot-drawer';
import {CopilotFab} from '@on-the-go-web/library/components/copilot-drawer/copilot-fab';
import {CopilotService, LocationsDataService} from '@on-the-go-web/library/helpers';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map, Observable, startWith} from 'rxjs';

@Component({
  selector: 'otg-main.component',
  imports: [
    CommonModule,
    RouterModule,
    BottomNavComponent,
    SidenavComponent,
    SecurityPromptComponent,
    CopilotDrawer,
    CopilotFab,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent {
  private _authService = inject(AuthService);
  private _locationDataService = inject(LocationsDataService);
  private _router = inject(Router);
  protected readonly copilot = inject(CopilotService);

  locations$ = this._locationDataService.locations$;

  public logoPath$ = inject(LOGO_PATH_TOKEN);

  loggedIn$: Observable<boolean>;

  constructor() {
    this.loggedIn$ = this._authService.loggedIn$;
  }
}
